import React from "react"
import styled from "styled-components"
import BobAndSaylor from "../../../static/images/dashboard/bob-and-saylor"
import { colors, fontSize } from "buoy-theme"

const Container = styled.div`
  text-align: center;
  padding-bottom: 100px;
  line-height: 1.4;
  letter-spacing: 0.2px;
`

const Message = styled.p`
  color: ${colors.primary};
  ${fontSize("bodyLarger")}
  padding-top: 18px;
  margin: 0 auto;
`

const Footer = () => (
  <Container>
    <BobAndSaylor />
    <Message>All done!</Message>
  </Container>
)

export default Footer


// WEBPACK FOOTER //
// ./assets/dashboard/components/Footer.js